export class Fullscreen {
	static open(element: Element): void {
		if (element.requestFullscreen) {
			element.requestFullscreen();
		} else if (element["webkitRequestFullscreen"]) {
			element["webkitRequestFullscreen"]();
		} else if (element["mozRequestFullScreen"]) {
			element["mozRequestFullScreen"]();
		} else if (element["msRequestFullscreen"]) {
			element["msRequestFullscreen"]();
		}
	}
	static isActive(): boolean {
		const fullscreen = document.fullscreenElement || document["mozFullScreenElement"] || document["webkitFullscreenElement"] || document["msFullscreenElement"];
		if (fullscreen) {
			return true;
		}
		return false;
	}
	static exit(callback?: Function): void {
		if (document.exitFullscreen) {
			document.exitFullscreen();
		} else if (document["webkitExitFullscreen"]) {
			document["webkitExitFullscreen"]();
		} else if (document["mozCancelFullScreen"]) {
			document["mozCancelFullScreen"]();
		} else if (document["msExitFullscreen"]) {
			document["msExitFullscreen"]();
		}
		if ("function" === typeof callback) {
			setTimeout(callback, 200);
		}
	}
}